import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

// Render whole app
createRoot(document.getElementById("root")).render(<App />);
